<h5>Diagnosed Only</h5>
<p style="font-style: italic;">
  Only diagnosed {{ indicationDisplayName }} patients are available.
</p>
